export const UPDATE_PAGINATION_TOTAL_LOG: string = "UPDATE_PAGINATION_TOTAL_LOG";
export const UPDATE_PAGINATION_POSTS_PER_PAGE_LOG: string = "UPDATE_PAGINATION_POSTS_PER_PAGE_LOG";
export const UPDATE_PAGINATION_CURRENT_PAGE_LOG: string = "UPDATE_PAGINATION_CURRENT_PAGE_LOG";
export const UPDATE_LOADING_STATE_LOG: string = "UPDATE_LOADING_STATE_LOG";
export const UPDATE_NOTFOUND_STATE_LOG: string = "UPLOAD_NOTFOUND_STATE_LOG";
export const UPDATE_TABLE_STATE_LOG: string = "UPDATE_TABLE_STATE_LOG";
export const UPDATE_SEARCH_LOG: string = "UPDATE_SEARCH_LOG";
export const UPDATE_SEARCH_CURRENT_PAGE_LOG: string = "UPDATE_SEARCH_CURRENT_PAGE_LOG";

export function updateLogsPaginationtTotal(totalPostsLog: number): IUpdatePaginationTotalActionType {
    return { type: UPDATE_PAGINATION_TOTAL_LOG, totalPostsLog:totalPostsLog };
}
export function updateLogsPaginationtPostsPerPage(postsPerPageLog: number): IUpdatePaginationPostsPerPageActionType {
    return { type: UPDATE_PAGINATION_POSTS_PER_PAGE_LOG, postsPerPageLog:postsPerPageLog };
}
export function updateLogsPaginationcurrentPage(currentPageLog: number): IUpdatePaginationCurrentPageActionType {
    return { type: UPDATE_PAGINATION_CURRENT_PAGE_LOG, currentPageLog:currentPageLog };
}
export function updateLogsLoadingState(loadingLog: string): IUpdateLoadingStateActionType {
    return { type: UPDATE_LOADING_STATE_LOG, loadingLog:loadingLog };
}
export function updateLogsNFState(notFoundLog: string): IUpdateNFStateActionType {
    return { type: UPDATE_NOTFOUND_STATE_LOG, notFoundLog:notFoundLog };
}
export function updateLogsTableState(tableLog: string): IUpdateTableStateActionType {
    return { type: UPDATE_TABLE_STATE_LOG, tableLog:tableLog };
}
export function updateLogsSearchState(searchLog: string): IUpdateSearchStateActionType {
    return { type: UPDATE_SEARCH_LOG, searchLog:searchLog };
}
export function updateLogsSearchCurrentPageState(currentPageSearchLog: number): IUpdateCurrentPageSearchStateActionType {
    return { type: UPDATE_SEARCH_CURRENT_PAGE_LOG, currentPageSearchLog:currentPageSearchLog };
}

interface IUpdatePaginationTotalActionType { type: string, totalPostsLog: number}
interface IUpdatePaginationPostsPerPageActionType { type: string, postsPerPageLog: number}
interface IUpdatePaginationCurrentPageActionType { type: string, currentPageLog: number}
interface IUpdateLoadingStateActionType { type: string, loadingLog: string}
interface IUpdateNFStateActionType { type: string, notFoundLog: string}
interface IUpdateTableStateActionType { type: string, tableLog: string}
interface IUpdateSearchStateActionType { type: string, searchLog: string}
interface IUpdateCurrentPageSearchStateActionType { type: string, currentPageSearchLog: number}